import React, { Component } from "react";

import {
  HomeSlider,
  HomeTitle,
  Img,
  CoverSection,
  ResponsiveYouTubeIframe,
} from "../../Components/UI/UI";

import { getWeather, asyncgetWeather, isMobile } from "../../Utility/Utility";

import Menu from "../../Components/Menu/Menu";
import Footer from "../../Components/Footer/Footer";

import "./CoronaVirus.css";

class CoronaVirus extends Component {
  state = {
    telAvivWeather: 0,
    waterTemp: 0,
    jerusalemWeather: 0,
  };

  componentDidMount() {
    Promise.all([asyncgetWeather()]).then((response) => {
        var weather = response[0];
     

    
        // console.log(typeof weather);
        // console.log( weather);

        const jerusalemTemperature = '20';
        const deadSeaTemperature = '20';
        const telAvivTemperature = '20';
        const telAvivWaterTemp = '20';

        if (typeof weather !== 'object') {
            // console.log('The weather variable is a string.');
            
            // Find the starting index of the JSON object
            const jsonStartIndex = weather.indexOf('{"jerusalem"');
    
            if (jsonStartIndex !== -1) {
                  // Extract the JSON substring
                  const jsonString = weather.substring(jsonStartIndex);
      
                  // Log the extracted JSON string to verify
                  // console.log('Extracted JSON String:', jsonString);
      
                  try {
                      const weatherData = JSON.parse(jsonString);
                      // console.log('Parsed Weather Data:', weatherData);
      
                      // Accessing the required temperature values
                      const jerusalemTemperature = weatherData.jerusalem.temperature;
                      const deadSeaTemperature = weatherData.deadsea.temperature;
                      const telAvivTemperature = weatherData.telaviv.temperature;
                      const telAvivWaterTemp = weatherData.telaviv.water_temp;
      
                      // console.log('Jerusalem Temperature:', jerusalemTemperature);
                      // console.log('Dead Sea Temperature:', deadSeaTemperature);
                      // console.log('Tel Aviv Temperature:', telAvivTemperature);
                      // console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
      
                      // Set the state with the extracted values
                      this.setState({
                        
                          jerusalemWeather: jerusalemTemperature,
                          deadSeaWeather: deadSeaTemperature,
                          telAvivWeather: telAvivTemperature,
                          waterTemp: telAvivWaterTemp,
                      });
      
                  } catch (error) {
                      console.error('Error parsing JSON:', error);
                  }
              } else {
                  console.error('No JSON found in the weather response');
                  this.setState({
                    jerusalemWeather: jerusalemTemperature,
                    deadSeaWeather: deadSeaTemperature,
                    telAvivWeather: telAvivTemperature,
                    waterTemp: telAvivWaterTemp,
                });
              }
        } else {
            // console.log('The weather variable is an object.');
            this.setState({
                jerusalemWeather: weather.jerusalem.temperature,
                deadSeaWeather: weather.deadsea.temperature,
                telAvivWeather: weather.telaviv.temperature,
                waterTemp: weather.jerusalem.water_temp,
            });
        }

    });

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateDimensions);
}

  render() {
    return (
      <div className="page align-left page-Corona-virus">
        <Menu />
        {/*<HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />*/}
        {!isMobile() ? (
          <CoverSection
            desktopImg={"/HomeSlider/corona.jpg"}
            mobileImg={"/HomeSlider/M/uk/4.jpg"}
            cssClass={"north"}
            waterTemp={this.state.waterTemp}
            telAvivWeather={this.state.telAvivWeather}
            jerusalemWeather={this.state.jerusalemWeather}
          />
        ) : (
          <div className="ac-corona-mobile-video">
            <ResponsiveYouTubeIframe vidId={"yE5MV_10cZw"} />
          </div>
        )}

        <div className="container">
          <div className="ac-new-container">
            <div className="ac-new-container">
              <h2 className="ac-pink"></h2>
              <h2 className="ac-pink ac-pink ac-margin-top-1 ac-bigger">
                Bentornato
              </h2>
              <h2>
                <span>
                  <strong>
                    I viaggi in Israele per i cittadini stranieri completamente
                    vaccinati
                  </strong>
                </span>
              </h2>
              <br />A partire dal 1° novembre 2021 i cittadini stranieri che
              hanno completato il ciclo vaccinale possono entrare in Israele nel
              rispetto dei seguenti termini e condizioni:
              <ul>
                <li>
                  1. Non aver soggiornato in un Paese della zona rossa nei 14
                  giorni precedenti l'ingresso in Israele.
                </li>
                <li>
                  2. Aver ricevuto un vaccino autorizzato dalla WHO, alle
                  condizioni definite di seguito.
                </li>
                <li>
                  3. Entrare in Israele esclusivamente tramite l'aeroporto di
                  Ben Gurion.
                </li>
                <li>
                  4. Non presentare altri impedimenti all'ingresso in Israele.
                </li>
                <li>
                  5. I cittadini stranieri che non rispettano le condizioni
                  sopra illustrate possono richiedere l'ingresso in Israele
                  attraverso il{" "}
                  <a
                    href="https://survey.gov.il/he/PCR2"
                    target="_blank"
                    rel="noopener"
                  >
                    Comitato per le eccezioni
                  </a>
                </li>
              </ul>
              <h2 className="ac-pink">Vaccini riconosciuti</h2>
              <br />
              <p className="ac-align-left-15">
                Israele riconosce e autorizza i seguenti vaccini: Moderna,
                Pfizer, Johnson & Johnson – Janssen, AstraZeneca, Covishield,
                Sinopharm, Sinovac, SputniK-V (nel rispetto delle condizioni
                riportate di seguito)
              </p>
              <br />
              <p className="ac-align-left-15">
                <strong>
                  Quali sono i soggetti che Israele riconosce come completamente
                  vaccinati?
                </strong>
              </p>
              <p className="ac-align-left-15">
                Cittadini stranieri vaccinati con Pfizer / Moderna / AstraZeneca
                / Sinovac o Sinopharm:
              </p>
              <ul>
                <li>
                  ● Debbono aver completato il ciclo di due dosi vaccinali e
                  aver ricevuto la seconda dose almeno 14 giorni prima
                  dell'ingresso in Israele (ma non più di 180 giorni al momento
                  della partenza da Israele).
                </li>
                <li>
                  ● Se si è stati vaccinati con una dose di richiamo, debbono
                  essere trascorsi almeno 14 giorni dalla somministrazione prima
                  dell'ingresso in Israele.
                </li>
              </ul>
              &nbsp;
              <p className="ac-align-left-15">
                Cittadini stranieri vaccinati con il vaccino Johnson & Johnson -
                Janssen:
              </p>
              <ul>
                <li>
                  ● Debbono essere trascorsi almeno 14 giorni dalla data di
                  vaccinazione (ma non più di 180 giorni al momento della
                  partenza da Israele).
                </li>
                <li>
                  ● Se si è stati vaccinati con una dose di richiamo, debbono
                  essere trascorsi almeno 14 giorni dalla somministrazione prima
                  dell'ingresso in Israele.
                </li>
              </ul>
              &nbsp;
              <p className="ac-align-left-15">
                Cittadini stranieri vaccinati con il vaccino Sputnik:
              </p>
              <ul>
                <li>
                  ● A partire dal 15/11/2021, i cittadini stranieri vaccinati
                  con il vaccino Sputnik che siano risultati positivi al test
                  sierologico per il COVID effettuato in Israele (dovranno
                  restare in isolamento fino ad ottenere un risultato negativo).
                </li>
                <li>
                  ● Debbono aver completato il ciclo di due dosi vaccinali e
                  aver ricevuto la seconda dose almeno 14 giorni prima
                  dell'ingresso in Israele (ma non più di 180 giorni al momento
                  della partenza da Israele).
                </li>
                <li>
                  ● Se si è stati vaccinati con una dose di richiamo, debbono
                  essere trascorsi almeno 14 giorni dalla somministrazione prima
                  dell'ingresso in Israele.
                </li>
              </ul>
              <h2>
                <strong>
                  Ingresso in Israele per persone completamente guarite dal
                  COVID
                </strong>
              </h2>
              <br />
              <p className="ac-align-left-15">
                I cittadini stranieri che siano guariti dal COVID potranno
                entrare in Israele se in possesso di un certificato digitale che
                possa essere autenticato dal sistema sanitario israeliano e dopo
                essere risultati negativi al test NAAT (test molecolare simile
                al PCR).
              </p>
              <ul>
                <li>
                  ● Al momento di entrare in Israele debbono essere trascorsi
                  almeno 11 giorni dal risultato positivo del test (ma non più
                  di 190 giorni al momento della partenza da Israele)
                </li>
                <li>
                  ● Occorre aver ricevuto almeno una dose di un vaccino
                  autorizzato dalla WHO (non ha importanza l'ordine degli
                  eventi).
                </li>
              </ul>
              <a href="#_ednref1" name="_edn1"></a>
              <b>
                * Entry for recoverees is only applicable for those coming from
                countries that issue certificates that the Israeli MOH systems
                can digitally authenticate, which is not available for people
                traveling from the USA or Canada
              </b>
              <h2>
                <strong>Procedura di ingresso in Israele</strong>
              </h2>
              <br />
              <ul className="ac-wrpr-num">
                <li className="ac-num-li">
                  1. Occorre effettuare un test PCR fino a 72 ore prima del volo
                </li>
                <li className="ac-num-li">
                  2. Occorre compilare una dichiarazione prima di entrare in
                  Israele.
                  <ul>
                    <li>
                      ● I passeggeri in possesso di un certificato digitale
                      verificabile debbono scansionare o caricare il certificato
                      di immunizzazione o di guarigione e allegarlo al modulo di
                      ingresso: riceveranno un green pass prima dell'imbarco.
                    </li>
                    <li>
                      ● I passeggeri sprovvisti di certificato digitale
                      verificabile dovranno dichiarare la loro situazione
                      vaccinale nel modulo di ingresso e compilare la domanda
                      per abbreviare il periodo di isolamento. Quindi, dovranno
                      allegare i documenti pertinenti per ricevere il green pass
                      prima dell'imbarco.
                    </li>
                  </ul>
                </li>
                <li className="ac-num-li">
                  3. Al momento dell'imbarco, occorre presentare i seguenti
                  documenti
                  <ul>
                    <li>
                      ● Certificato di un test PCR negativo effettuato entro le
                      72 ore precedenti al volo.
                    </li>
                    <li>
                      ● Ricevuta di conferma dell'invio di una dichiarazione di
                      ingresso.
                    </li>
                    <li>
                      ● Certificato vaccinale attestante l'effettuazione della
                      vaccinazione in conformità con le disposizioni sopra
                      riportate.
                    </li>
                    <li>
                      ● Certificato di guarigione autenticabile digitalmente dal
                      sistema sanitario israeliano, indicante la guarigione, in
                      conformità con le disposizioni sopra riportate.
                    </li>
                    <li>
                      ● Certificato digitale attestante l'avvenuta guarigione
                      dal COVID in conformità con le disposizioni sopra
                      riportate.
                    </li>
                    <li>
                      ● Permesso eccezionale di ingresso rilasciato dal
                      Ministero dell'interno (definizione delle eccezioni,
                      gruppi)
                    </li>
                  </ul>
                </li>
                <li className="ac-num-li">
                  4. All'aeroporto di Ben Gurion verranno effettuati dei test di
                  conformità della documentazione a campione da parte della
                  Population Authority.
                </li>
                <li className="ac-num-li">
                  5. Al momento dell'atterraggio all'aeroporto di Ben Gurion
                  occorre sottoporsi a un test PCR. È necessario un periodo di
                  isolamento fino all'ottenimento di un risultato negativo o per
                  24 ore, a seconda di quale sia il termine più breve.
                </li>
                <li className="ac-num-li">
                  6. I viaggiatori vaccinati con Sputnik dovranno sottoporsi a
                  un test sierologico all'aeroporto di Ben Gurion e
                  all'isolamento fino all'ottenimento di un risultato negativo
                  (in aggiunta all'isolamento fino all'ottenimento del risultato
                  negativo del test PCR effettuato all'arrivo).
                </li>
              </ul>
              <br />
              <p className="ac-align-center">
                Per consultare l'elenco dei Paesi che rilasciano certificati che
                il sistema sanitario israeliano può autenticare digitalmente:
                <br />
                <a
                  href="https://ec.europa.eu/info/live-work-travel-eu/coronavirus-response/safe-covid-19-vaccines-europeans/eu-digital-covid-certificate_en"
                  target="_blank"
                  rel="noopener"
                  className="ac-align-center"
                >
                  https://ec.europa.eu/info/live-work-travel-eu/coronavirus-response/safe-covid-19-vaccines-europeans/eu-digital-covid-certificate_en
                </a>
              </p>
              <br />
              <p className="ac-align-center">
                Per ulteriori informazioni sul protocollo di ingresso cliccare
                qui:
                <br />
                <a
                  href="https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air"
                  className="ac-align-left-15"
                  target="_blank"
                  rel="noopener"
                >
                  https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air
                </a>
              </p>
              <br />
              <p className="ac-align-center">
                <strong>
                  <span>
                    Le linee guida sopra riportate sono illustrate
                    dettagliatamente di seguito a titolo informativo e di
                    riferimento. In caso di dubbi, consultare le linee guida
                    pubblicate sul sito del Ministero della Sanità israeliano in
                    quanto riportanti le informazioni più recenti e accurate.
                  </span>
                </strong>
                <br />{" "}
                <a
                  href="https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air"
                  className="ac-align-center"
                  target="_blank"
                  rel="noopener"
                >
                  https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air
                </a>
              </p>
              <h2 className="ac-pink">A presto</h2>
            </div>

            <div className="ac-inner-video">
              <ResponsiveYouTubeIframe vidId={"LSb4Lmuw_Kw"} />
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default CoronaVirus;



// WEBPACK FOOTER //
// ./src/Pages/CoronaVirusPage/CoronaVirus.js